import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'
import Mopra from '@material-ui/icons/Spa'
import LandDeformation from '@material-ui/icons/LocationCity'
import RiverIce from '@material-ui/icons/DirectionsBoat'
import SmartIce from '@material-ui/icons/AcUnit'
import PolarView from '@material-ui/icons/RemoveRedEye'
import InlandWaters from '@material-ui/icons/Pool'
import WaterMonitoring from '@material-ui/icons/InvertColors'
import Pipeline from '@material-ui/icons/Timeline'

// import WaterMonitoring from '../assets/service-icons/water-monitoring.svg'
// import Icon from '@material-ui/core/Icon'
// console.log(InlandWaters)
// console.log(typeof(InlandWaters))
// console.log(WaterMonitoring)
// console.log(typeof(WaterMonitoring))
// console.log(typeof(<img src={WaterMonitoring}/>))
// const Test = () => {
//   return (
//     <img src={WaterMonitoring}/>
//   )
// }
// console.log(<img src={WaterMonitoring} />)
// window.svg = WaterMonitoring
// export Mopra
// export LandDeformation
// export RiverIce
// export SmartIce
// export PolarView
// export InlandWaters

// const TestIcon = <SvgIcon><path d="M178.9,680.3c-60.3,0-120.5-48.9-166.4-146.8c-3.2-6.9-3.2-18.2,0-25.1c3.2-6.9,8.5-6.9,11.8,0c85.3,181.9,224.1,181.9,309.4,0c3.2-6.9,8.5-6.9,11.8,0c3.2,6.9,3.2,18.2,0,25.1C299.4,631.4,239.1,680.3,178.9,680.3z M500,680.7c-62.8,0-121.9-52.3-166.4-147.1c-3.2-6.9-3.2-18.2,0-25.1c3.2-6.9,8.5-6.9,11.8,0c41.4,88.2,96.3,136.7,154.7,136.7c58.4,0,113.3-48.5,154.7-136.7c3.2-6.9,8.5-6.9,11.8,0c3.2,6.9,3.2,18.1,0,25.1C622,628.4,562.8,680.7,500,680.7z M821.1,680.3c-60.3,0-120.5-48.9-166.4-146.8c-3.2-6.9-3.2-18.2,0-25.1c3.2-6.9,8.5-6.9,11.8,0c85.3,181.9,224.1,181.9,309.3,0c3.2-6.9,8.5-6.9,11.8,0c3.2,6.9,3.2,18.2,0,25.1C941.7,631.4,881.4,680.3,821.1,680.3z M178.9,496.4c-60.3,0-120.5-48.9-166.4-146.8c-3.2-6.9-3.2-18.2,0-25.1c3.2-6.9,8.5-6.9,11.8,0c85.3,181.9,224.1,181.9,309.4,0c3.2-6.9,8.5-6.9,11.8,0c3.2,6.9,3.2,18.2,0,25.1C299.4,447.4,239.1,496.4,178.9,496.4z M500,496.7c-62.8,0-121.9-52.3-166.4-147.1c-3.2-6.9-3.2-18.2,0-25.1c3.2-6.9,8.5-6.9,11.8,0c41.4,88.2,96.3,136.7,154.7,136.7c58.4,0,113.3-48.5,154.7-136.7c3.2-6.9,8.5-6.9,11.8,0c3.2,6.9,3.2,18.1,0,25.1C622,444.4,562.9,496.7,500,496.7z M821.1,496.4c-60.3,0-120.5-48.9-166.4-146.8c-3.2-6.9-3.2-18.2,0-25.1c3.2-6.9,8.5-6.9,11.8,0c85.3,181.9,224.1,181.9,309.3,0c3.2-6.9,8.5-6.9,11.8,0c3.2,6.9,3.2,18.2,0,25.1C941.7,447.4,881.4,496.4,821.1,496.4z"/></SvgIcon>


      
export const SERVICE_ICONS = {
  'Pipeline': Pipeline,
  'InlandWaters': WaterMonitoring,
  'Mopra': Mopra,
  'LandDeformation': LandDeformation,
  'RiverIce': RiverIce,
  'SmartIce': SmartIce,
  'PolarView': PolarView,
  'LeakDetection': LandDeformation
}



// WEBPACK FOOTER //
// ./src/config/icons.js